import React from 'react';
import { Gift, Utensils, Users, Percent, CreditCard, Heart, MapPin, Sparkles, CheckCircle2 } from 'lucide-react';
import { DESTINATION_SPECIFIC_DATA } from '../../constants/destinationData';

const ICON_MAP = {
  Gift,
  Utensils,
  Users,
  Percent,
  CreditCard,
  Heart,
  MapPin,
  Sparkles,
  CheckCircle2
};

export default function SummerOffers({ slug = 'shimla' }) {
  const data = DESTINATION_SPECIFIC_DATA[slug] || DESTINATION_SPECIFIC_DATA['shimla'];
  const offers = data.offers;

  return (
    <section className="py-16 bg-brand-blue relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange via-white to-brand-orange" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block bg-brand-orange text-white text-[11px] font-bold uppercase tracking-[0.2em] px-3 py-1 rounded-md mb-4 animate-pulse">
            Limited Time · Ends Soon
          </div>
          <h2 className="font-poppins text-[32px] lg:text-[42px] text-white leading-tight mb-4">Season <span className="text-brand-orange">Mega Offers</span></h2>
          <p className="text-white/70 text-[16px] lg:text-[18px]">Book your escape today and unlock exclusive benefits.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {offers.map((o, i) => {
            const Icon = ICON_MAP[o.icon] || Gift;
            return (
              <div key={i} className="bg-white/5 border border-white/10 p-6 rounded-2xl backdrop-blur-sm hover:bg-white/10 transition-colors">
                <div className="w-12 h-12 rounded-xl bg-brand-orange/20 flex items-center justify-center mb-4">
                  <Icon className="text-brand-orange" size={24} />
                </div>
                <h3 className="text-white font-poppins font-bold text-[18px] mb-2">{o.title}</h3>
                <p className="text-white/60 text-[14px] leading-relaxed">{o.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
